/**
 * append object of options as query string values to url
 * @param url string
 * @param options Object
 */
export default function objectToQueryString(url, options) {
	if (!options) {
		return url
	}

	const queryParams = Object.entries(options)
		.filter(
			([, value]) => value !== null && value !== undefined && value !== '' && value !== false
		)
		.map(([key, value]) => {
			const stringValue = String(value) // Convert value to string
			return `${encodeURIComponent(key)}=${encodeURIComponent(stringValue)}`
		})
		.join('&')

	return queryParams
		? url.includes('?')
			? `${url}&${queryParams}`
			: `${url}?${queryParams}`
		: url
}
